
import React, { useState, useEffect, Fragment, useRef } from 'react';
import {
  Row, Button, FormGroup, Label, Input, Alert, Form, FormInput, Modal,
  ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText,
  Card, CardTitle, CardText, Col
} from 'reactstrap';
import * as IoIcons from 'react-icons/io';
import * as AiIcons from 'react-icons/ai'
import Navbarh from '../navbar/Navbar';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import Moment from 'moment';
import * as subscriptions from '../../graphql/subscriptions';
import { useReactToPrint } from 'react-to-print';
import { listTickets, listTicketUltimoNumeros, listUsuarios, listTicketStatuses } from '../../graphql/queries';
import {
  createTickets, updateTickets, updateTicketUltimoNumero, createTicketUltimoNumero, createTicketStatus,
  createNotificaciones, updateNotificaciones, createNotificacionesNuevas
} from '../../graphql/mutations';
//import { Storage } from 'aws-amplify';// API,
import TimeField from 'react-simple-timefield';
import { GetTicketID, GetTickets, GetTicketsStatus, GetUsuarios } from '../queries/Queries';
import { generateClient } from "aws-amplify/api";
import { getUrl, list, uploadData } from "@aws-amplify/storage";

const API = generateClient();

const initialfFormState = { formType: 'Sistema de tickets' }

//import ImageUploader from 'react-images-upload';       
const initialFormState = {
  fechaDeTicket: Moment(new Date()).format("YYYY-MM-DD"), horaApertura: "00:00", numero: 0, modulo: '', titulo: '',
  descripcion: '', estatus: 'Abierto', prioridad: '', activo: true, Reg_Ins_Usuario: '',
  Reg_Mod_Usuario: '', image: '', archivo: ''
}
//Función principal 
function Tickets() {
  const [usuariosSoporte, setUsuariosSoporte] = useState([]);
  const [usuariosSinFiltro, setUsuariosSinFiltro] = useState([]);
  const [formState, updateFormState] = useState(initialfFormState);
  const [mensajeAlert, setMensajeAlert] = useState("Hola");
  const [color, setColor] = useState("warning");
  const [aVisible, setAVisible] = useState(false);
  const [cargando, setCargando] = useState(false);
  const onDismiss = () => setAVisible(false);
  const [formData, updateFormData] = useState(initialFormState);
  const [searchBy, setSearchBy] = useState("número");
  const [search, setSearch] = useState("");
  const [isDisabled, setisDisabled] = useState(false);
  const { formType } = formState;
  const userName = window.$name;
  const [userNombreCompleto, setUserNombreCompleto] = useState("");
  const ptickets = window.$Tickets ? window.$Tickets : false;
  const stickets = window.$TicketsSoporte ? window.$TicketsSoporte : false;
  const atickets = window.$TicketsAuditor ? window.$TicketsAuditor : false;
  const [tickets, setTickets] = useState([]);
  const [ticketM, setTicketM] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [TicketsSinFiltro, setTicketsSinFiltro] = useState([]);
  const [historialTicket, setHistorialTicket] = useState([]);
  const [estadoTickets, setEstadoTickets] = useState("todos");
  const [paginas, setPaginas] = useState([]);
  const [ultimoNumeroP, setultimoNumeroP] = useState(0);
  const [imagenRepetida, setImagenRepetida] = useState(false);
  const [DocumentoRepetido, setDocumentoRepetido] = useState(false);
  const [editarImagen, setEditarImagen] = useState(false);
  const [editarArchivo, setEditarArchivo] = useState(false);
  const [imagen, setImagen] = useState({});
  const [archivo, setArchivo] = useState({});
  const [respuestaUsuario, setRespuestaUsuario] = useState(false);
  const [asignadosAMi, setAsignadosAMi] = useState(false);
  const [mostrandoHistorial, setMostrandoHistorial] = useState(false);

  Moment.locale('en');
  var now = new Date();
  var now2 = new Date();
  now2.setMonth(now2.getMonth() - 1);
  const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
  const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));

  //Método que maneja los cambios de página
  function handlePageChangeTickets(TicketsFromAPI, pageNumber) {
    setAVisible(false);
    setCargando(false);
    setCurrentPage(pageNumber);
    busquedaTickets(TicketsSinFiltro, estadoTickets, searchBy, search, pageNumber, asignadosAMi);
  }
  // current page
  const [currentPage, setCurrentPage] = useState(1);

  // total records per page to display
  const recordPerPage = 20;

  // range of pages in paginator
  const pageRange = 5;


  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  function onChangesRFecha(e) {
    e.persist()
    var fechafin = rfechafin;
    var fechaini = rfechaini;
    if (e.target.name === "fechaIni") {
      setRfechaini(e.target.value);
      fechaini = e.target.value;
    }
    else {
      setRfechafin(e.target.value);
      fechafin = e.target.value;
    }
    fetchTickets(fechaini, fechafin);


  }

  function buscarpor(e) {
    setAVisible(false);
    setSearchBy(e.target.value);
    //if (search && e.target.value !== "fecha")
    busquedaTickets(TicketsSinFiltro, estadoTickets, e.target.value, search, currentPage, asignadosAMi);
  }


  //Método useEffect que sirve para ejecutar funciones al abrir módulo
  useEffect(() => {
    fetchTickets(rfechaini, rfechafin);
    fetchUsuario();
  }, []);

  async function fetchTickets(fechainicial, fechafinal) {
    //Filtro por planeación activa
    setCargando(true);
    var filter = "";
    if (stickets === true || atickets === true) {
      filter = {
        and: [{
          activo: {
            eq: true
          }
        },
        {
          fechaDeTicket: {
            ge: fechainicial
          }
        },
        {
          fechaDeTicket: {
            le: fechafinal
          }
        }]
      }

    } else {
      filter = {
        and: [{
          activo: {
            eq: true
          }
        },
        {
          fechaDeTicket: {
            ge: fechainicial
          }
        },
        {
          fechaDeTicket: {
            le: fechafinal
          }
        },
        {
          Reg_Ins_Usuario: {
            eq: userName
          }
        }]
      }
    }


    const apiData = await GetTickets(filter);
    const TicketsFromAPI = apiData.sort((a, b) =>
      a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0);

    await Promise.all(TicketsFromAPI.map(async ticket => {
      if (ticket.image) {
        const image = await getUrl({ key: ticket.image });//await Storage.get(ticket.image);
        ticket.imagename = ticket.image;
        ticket.image = image.url.toString();
      }
      if (ticket.archivo) {
        const archivo = await getUrl({ key: ticket.archivo });//await Storage.get(ticket.archivo);
        ticket.archivoname = ticket.archivo;
        ticket.archivo = archivo.url.toString();
      }
      return ticket;
    }))

    setTicketsSinFiltro(TicketsFromAPI);
    busquedaTickets(TicketsFromAPI, estadoTickets, searchBy, search, currentPage, asignadosAMi);
    setCargando(false);
  }
  async function fetchTicketsID(ticketID) {
    //Filtro por planeación activa
    setCargando(true);
    const ticket = await GetTicketID(ticketID);
    if (ticket.image) {
      const image = await getUrl({ key: ticket.image });//await Storage.get(ticket.image);
      ticket.imagename = ticket.image;
      ticket.image = image.url.toString();
    }
    if (ticket.archivo) {
      const archivo = await getUrl({ key: ticket.archivo });// await Storage.get(ticket.archivo);
      ticket.archivoname = ticket.archivo;
      ticket.archivo = archivo.url.toString();
    }
    setCargando(false);
    return ticket;
  }
  async function fetchHistorialTicket(ticketID) {
    setCargando(true);
    let filter = {
      and: [
        {
          ticketsID: {
            eq: ticketID
          }
        },
        {
          activo: {
            eq: true
          }
        }
      ]

    }

    const apiData = await GetTicketsStatus(filter);

    const dataFromAPI = apiData.sort((a, b) =>
      a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);

    await Promise.all(dataFromAPI.map(async ticket => {
      if (ticket.campoModificado === "Archivo" || ticket.campoModificado === "Imagen") {
        if (ticket.valorActual) {
          const archivo = await getUrl({ key: ticket.valorActual });//await Storage.get(ticket.valorActual);
          ticket.urlArchivo = archivo.url.toString();
        }
        if (ticket.valorAnterior) {
          const archivoAterior = await getUrl({ key: ticket.valorAnterior });//await Storage.get(ticket.valorAnterior);
          ticket.archivoAnterior = archivoAterior.url.toString();
        }
      }
      return ticket;
    }))
    setHistorialTicket(dataFromAPI);
    setCargando(false);
  }
  //Obtienen los usuarios con permisos de soporte
  async function fetchUsuario() {
    let filter = {
      activo: {
        eq: true
      }
    }

    const apiData = await GetUsuarios(filter);

    const dataFromAPI = apiData.sort((a, b) =>
      a.nombreCompleto > b.nombreCompleto ? 1 : a.nombreCompleto < b.nombreCompleto ? -1 : 0);
    const datosUsuario = dataFromAPI.filter(usuarios => usuarios.usuario === userName)
    if (datosUsuario[0]) {
      if (datosUsuario[0].TicketsSoporte === false || !datosUsuario[0].nombreCompleto.toLowerCase().includes("generico"))
        updateFormData(() => ({ ...formData, "nombreSolicitante": datosUsuario[0].nombreCompleto }));
      setUserNombreCompleto(datosUsuario[0].nombreCompleto);
    }
    setUsuariosSinFiltro(dataFromAPI.filter(usuarios => usuarios.TicketsSoporte === true));
    setUsuariosSoporte(dataFromAPI.filter(usuarios => usuarios.TicketsSoporte === true));
  }

  function agregarTicket() {
    setCargando(false);
    setAVisible(false);
    formData.horaApertura = Moment(new Date()).format("HH:mm");
    updateFormState(() => ({ ...formState, formType: "Nuevo ticket" }));
  }
  function clicEditar(ticket) {
    setCargando(false);
    setAVisible(false);
    delete ticket.comentariosUsuario;
    delete ticket.RespuestaSoporte;
    delete ticket.comentariosSoporte;
    updateFormData(ticket);
    setTicketM(ticket);
    updateFormState(() => ({ ...formState, formType: "Editar ticket" }));
  }
  function clicAccion(ticket, accion) {
    setCargando(false);
    setAVisible(false);
    setRespuestaUsuario(false);
    setMostrandoHistorial(true);
    delete ticket.comentariosUsuario;
    delete ticket.RespuestaSoporte;
    delete ticket.comentariosSoporte;
    updateFormData(ticket);
    setTicketM(ticket);
    fetchHistorialTicket(ticket.id);
    updateFormState(() => ({ ...formState, formType: accion }));
  }

  function onChanges(e) {
    e.persist()
    if (e.target.name === "estatus" && e.target.value !== "Cerrado") {
      if (e.target.value === "Atendido") {
        updateFormData(() => ({
          ...formData, [e.target.name]: e.target.value, "fechaDeAtendido": formData.fechaDeAtendido ? formData.fechaDeAtendido : Moment(now2).format("YYYY-MM-DD"),
          horaAtendido: formData.horaAtendido ? formData.horaAtendido : Moment(now2).format("HH:mm")
        }));
      } else {
        updateFormData(() => ({ ...formData, [e.target.name]: e.target.value, "fechaDeAtendido": "", horaAtendido: "" }));
      }
    } else {
      updateFormData(() => ({ ...formData, [e.target.name]: e.target.value }));
    }
  }
  function pTickets() {
    setEditarImagen(false);
    setEditarArchivo(false);
    setRespuestaUsuario(false);
    setMostrandoHistorial(false);
    setImagen({});
    setArchivo({});
    updateFormData(initialFormState);
    setTicketM({});
    updateFormState(() => ({ ...formState, formType: "Sistema de tickets" }));
  }

  function onSearchFecha(e) {
    setAVisible(false);
    setSearch(e.target.value);
    busquedaTickets(TicketsSinFiltro, estadoTickets, searchBy, e.target.value, currentPage, asignadosAMi);
  }
  function onSearch(e) {
    setAVisible(false);
    setSearch(e.target.value);
    busquedaTickets(TicketsSinFiltro, estadoTickets, searchBy, e.target.value, currentPage, asignadosAMi);
  }
  function onAsignadosAMi(asignadoAMi) {
    setAVisible(false);
    setAsignadosAMi(asignadoAMi);
    busquedaTickets(TicketsSinFiltro, estadoTickets, searchBy, search, currentPage, asignadoAMi);
  }

  async function guardarTicket() {

    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    try {
      delete formData.indexpag;
      delete formData.imagename;
      delete formData.archivoname;
      if (imagenRepetida || DocumentoRepetido) {
        if (imagenRepetida && DocumentoRepetido) {
          setMensajeAlert("Imagen y documento repetidos: favor de seleccionar otros archivos o cambiarles el nombre y volver a intentarlo");
        } else if (imagenRepetida) {
          setMensajeAlert("Ya existe una imagen con el mismo nombre: favor de seleccionar otra imagen o cambiar el nombre de la imagen y volver a intentarlo");
        } else if (imagenRepetida) {
          setMensajeAlert("Ya existe un archivo con el mismo nombre: favor de seleccionar otro archivo o cambiar el nombre del archivo y volver a intentarlo");
        }
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        window.scrollTo(0, 0);
      } else if (!formData.modulo || !formData.titulo || !formData.descripcion || !formData.prioridad) {
        setMensajeAlert("Faltan datos: los campos marcados con un asterisco son obligatorios");
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        window.scrollTo(0, 0);
        setisDisabled(false);

      } else {
        //Obteniendo el número de ID de tickets  
        var numeroUP = 1;
        const apiData = await API.graphql({ query: listTicketUltimoNumeros });
        const ultimarFromAPI = apiData.data.listTicketUltimoNumeros.items;
        await Promise.all(ultimarFromAPI.map(async ultimonumerotickets => {
          numeroUP = ultimonumerotickets.numero + 1;
          ultimonumerotickets.numero = numeroUP;

          delete ultimonumerotickets.createdAt;
          delete ultimonumerotickets.updatedAt;
          delete ultimonumerotickets.__typename;
          ultimonumerotickets.Reg_Mod_Usuario = userName;
          await API.graphql({ query: updateTicketUltimoNumero, variables: { input: ultimonumerotickets } })

          return ultimonumerotickets;
        }))
        if (!ultimarFromAPI.length) {
          await API.graphql({
            query: createTicketUltimoNumero, variables: {
              input: {
                numero: numeroUP,
                activo: true, Reg_Ins_Usuario: userName
              }
            }
          });

        }
        // Seguardan los datos...
        formData.numero = numeroUP;
        formData.Reg_Ins_Usuario = userName;
        formData.horaApertura = stickets === false ? Moment(new Date()).format("HH:mm") : formData.horaApertura;
        if (formData.asignadoA)
          formData.estatus = "Asignado"
        await API.graphql({ query: createTickets, variables: { input: formData } });
        //Se guarda la imagen 
        if (formData.image) {
          await uploadData({ key: imagen.name, data: imagen });
        }
        //Se guarda el archivo 
        if (formData.archivo) {
          await uploadData({ key: archivo.name, data: archivo });
        }
        // Se crea una notificación de la creación del ticket
        if (!stickets) {
          const nombres = usuariosSoporte.map(u => u.usuario).join(',');
          const notificaciones = {
            modulo: "Atención a usuarios",
            Accion: "Nuevos tickets se han creados",
            notificacion: "Se ha creado un nuevo ticket con el número: " + formData.numero,
            fecha: Moment(new Date()).format("YYYY-MM-DD"),
            hora: Moment(new Date()).format("HH:mm"),
            leido: false,
            usuarioDe: userName,
            usuarioPara: "," + nombres + ",",
            paraSoporte: true,
            activo: true,
            Reg_Ins_Usuario: userName
          };
          setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones" + JSON.stringify(notificaciones));
          let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
          //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
          notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
          await Promise.all(
            usuariosSoporte.map(async (not, i) => {
              const notific = { ...notificaciones, usuarioPara: not.usuario };
              //Se establece para qué usuario es la notificación
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones nuevas" + JSON.stringify(notificaciones));
              await API.graphql({ query: createNotificacionesNuevas, variables: { input: notific } });
            })
          );

        }
        if (stickets && formData.estatus === "Asignado" && userNombreCompleto != formData.asignadoA) {
          const usuarioSoporte = usuariosSoporte.filter(usuarios => usuarios.nombreCompleto === formData.asignadoA);

          const notificaciones = {
            modulo: "Atención a usuarios",
            Accion: "Tickets se te han asignado",
            notificacion: "Se te ha asignado el ticket número " + formData.numero,
            fecha: Moment(new Date()).format("YYYY-MM-DD"),
            hora: Moment(new Date()).format("HH:mm"),
            leido: false,
            usuarioDe: userName,
            usuarioPara: usuarioSoporte[0].usuario,
            paraSoporte: false,
            activo: true,
            Reg_Ins_Usuario: userName
          };
          setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones" + JSON.stringify(notificaciones));
          let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
          //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
          notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
          //Se establece para qué usuario es la notificación
          setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones nuevas" + JSON.stringify(notificaciones));
          await API.graphql({ query: createNotificacionesNuevas, variables: { input: notificaciones } });
        }

        setMensajeAlert("Datos guardados");
        setColor("primary");
        setCargando(false);
        setAVisible(true);
        window.scrollTo(0, 0);
        setisDisabled(false);
        fetchTickets(rfechaini, rfechafin);
        pTickets();


      }

    } catch (e) {
      window.scrollTo(0, 0);
      //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar" + JSON.stringify(formData));
      setColor("warning");
      setCargando(false);
      setAVisible(true);
      setisDisabled(false);
    }

  }
  async function editarTicket() {

    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    try {
      if (!formData.modulo || !formData.titulo || !formData.descripcion || !formData.prioridad) {
        setMensajeAlert("Faltan datos: los campos marcados con un asterisco son obligatorios");
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        window.scrollTo(0, 0);
        setisDisabled(false);

      } else {
        //Se revisa si hay concurrencia.
        let filter = {
          id: {
            eq: formData.id
          }
        };
        //const apiData = await API.graphql({ query: listClientes, variables: { filter: filter, limit: 100000000 } });
        var nextToken = null;
        var apiData = [];
        do {
          const apiOData = await API.graphql({ query: listTickets, variables: { filter: filter, limit: 100000000, nextToken } });
          const odatos = await apiOData.data.listTickets.items;
          nextToken = await apiOData.data.listTickets.nextToken;
          apiData = await [...apiData, ...odatos];
        } while (nextToken != null);

        const ticketsFromAPI = await apiData;
        //Si la fecha de actualización es la misma, no hay concurrencia y se procede con la modificación 
        if (ticketsFromAPI[0].updatedAt === formData.updatedAt) {
          if (!editarImagen || formType != 'Editar ticket') {
            delete formData.image;
          }
          if (!editarArchivo || formType != 'Editar ticket') {
            delete formData.archivo;
          }

          if (formData.estatus === "Abierto" && formData.asignadoA)
            formData.estatus = "Asignado";


          //Datos para actualizar TicketStatus
          const cambios = {}
          cambios.ticketsID = formData.id;
          cambios.numero = formData.numero;
          cambios.Reg_Ins_Usuario = userName;
          cambios.fecha = Moment(new Date()).format("YYYY-MM-DD");
          cambios.hora = Moment(new Date()).format("HH:mm");
          cambios.activo = true;
          cambios.usuario = userNombreCompleto;
          /*if (formState === 'Editar ticket' || formState === 'Detalle de ticket') {
            cambios.cambioUsuario = true;
          }*/
          if (formType === 'Editar ticket' || formType === 'Detalle de ticket') {
            cambios.cambioUsuario = true;
            if (formData.comentarios) {
              formData.comentariosUsuario = formData.comentarios;//(formData.comentariosUsuario ? formData.comentariosUsuario + "\n" : "") + formData.comentarios;
            }
          }
          if (formType === 'Atender ticket') {
            cambios.cambioSoporte = true;
            if (formData.comentarios) {
              cambios.respuestaUsuario = respuestaUsuario;
              formData.comentariosSoporte = formData.comentarios;//(formData.comentariosSoporte ? formData.comentariosSoporte + "\n" : "") + formData.comentarios;
              if (respuestaUsuario) {
                formData.RespuestaSoporte = formData.comentarios;//(formData.RespuestaSoporte ? formData.RespuestaSoporte + "\n" : "") + formData.comentarios;
              }
            }
          }

          //Datos para actualizar Tickets
          formData.Reg_Mod_Usuario = userName;
          delete formData.indexpag;
          delete formData.createdAt;
          delete formData.updatedAt;
          delete formData.__typename;
          delete formData.imagename;
          delete formData.archivoname;
          delete formData.comentarios;
          // Se guardan los cambios en la tabla de Tickets
          let resulT = await API.graphql({ query: updateTickets, variables: { input: formData } });
          const ticketEdit = resulT.data.updateTickets;

          //Guardando la imagen si hubo cambios
          if (editarImagen) {
            await uploadData({ key: imagen.name, data: imagen });
          }
          //Guardando el archivo si hubo cambios
          if (editarArchivo) {
            await uploadData({ key: archivo.name, data: archivo });
          }

          //Se obtienen los datos del usuario de soporte
          const usuarioSoporte = usuariosSoporte.filter(usuarios => usuarios.nombreCompleto === formData.asignadoA);

          // Se guardan los cambios en la tabla de TicketStatus para llevar un historial de cambios                    
          //Si hubo cambios en  modulo  
          if (formData.modulo !== ticketM.modulo) {
            cambios.campoModificado = "Módulo";
            cambios.valorAnterior = ticketM.modulo;
            cambios.valorActual = formData.modulo;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
          }
          //Si hubo cambios en titulo
          if (formData.titulo !== ticketM.titulo) {
            cambios.campoModificado = "Título";
            cambios.valorAnterior = ticketM.titulo;
            cambios.valorActual = formData.titulo;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
          }
          //Si hubo cambios en descripcion
          if (formData.descripcion !== ticketM.descripcion) {
            cambios.campoModificado = "Descripción";
            cambios.valorAnterior = ticketM.descripcion;
            cambios.valorActual = formData.descripcion;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
          }
          //Si hubo cambios en estatus 
          if (formData.estatus !== ticketM.estatus) {
            cambios.campoModificado = "Estatus";
            cambios.valorAnterior = ticketM.estatus;
            cambios.valorActual = formData.estatus;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });

            //Notificaciones para el usuario
            if (usuarioSoporte[0].usuario != ticketEdit.Reg_Ins_Usuario) {
              const notificaciones = {
                modulo: "Atención a usuarios",
                Accion: "Cambio de estatus",
                notificacion: "Tu ticket con el número " + ticketEdit.numero + ", ha cambiado de estatus a " + formData.estatus,
                fecha: Moment(new Date()).format("YYYY-MM-DD"),
                hora: Moment(new Date()).format("HH:mm"),
                leido: false,
                usuarioDe: userName,
                usuarioPara: ticketEdit.Reg_Ins_Usuario,
                paraSoporte: false,
                activo: true,
                Reg_Ins_Usuario: userName
              };
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones" + JSON.stringify(notificaciones));
              let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
              //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
              notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
              //Se establece para qué usuario es la notificación
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones nuevas" + JSON.stringify(notificaciones));
              await API.graphql({ query: createNotificacionesNuevas, variables: { input: notificaciones } });
            }
          }
          //Si hubo cambios en asignadoA
          if (formData.asignadoA !== ticketM.asignadoA) {
            cambios.campoModificado = "Asignado a";
            cambios.valorAnterior = ticketM.asignadoA;
            cambios.valorActual = formData.asignadoA;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });

            //Notificaciones para el usuario
            if (usuarioSoporte[0].usuario != ticketEdit.Reg_Ins_Usuario) {
              const notificaciones = {
                modulo: "Atención a usuarios",
                Accion: "Ticket asignado",
                notificacion: "Tu ticket con el número " + ticketEdit.numero + ", ha sido asignado",
                fecha: Moment(new Date()).format("YYYY-MM-DD"),
                hora: Moment(new Date()).format("HH:mm"),
                leido: false,
                usuarioDe: userName,
                usuarioPara: ticketEdit.Reg_Ins_Usuario,
                paraSoporte: false,
                activo: true,
                Reg_Ins_Usuario: userName
              };
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones" + JSON.stringify(notificaciones));
              let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
              //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
              notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
              //Se establece para qué usuario es la notificación
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones nuevas" + JSON.stringify(notificaciones));
              await API.graphql({ query: createNotificacionesNuevas, variables: { input: notificaciones } });
            }
          }
          //Si hubo cambios en tipo
          if (formData.tipo !== ticketM.tipo) {
            cambios.campoModificado = "Tipo de Ticket";
            cambios.valorAnterior = ticketM.tipo;
            cambios.valorActual = formData.tipo;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
          }
          //Si hubo cambios en prioridad 
          if (formData.prioridad !== ticketM.prioridad) {
            cambios.campoModificado = "Prioridad";
            cambios.valorAnterior = ticketM.prioridad;
            cambios.valorActual = formData.prioridad;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
          }
          //Si hubo cambios en comentariosUsuario 
          if (formData.comentariosUsuario) {//!== ticketM.comentariosUsuario
            cambios.campoModificado = "Comentario del usuario";
            delete cambios.valorAnterior;
            //cambios.valorAnterior = ticketM.comentariosUsuario;
            cambios.valorActual = formData.comentariosUsuario;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });

            //Notificaciones para el soporte
            if (usuarioSoporte[0].usuario != ticketEdit.Reg_Ins_Usuario) {
              const notificaciones = {
                modulo: "Atención a usuarios",
                Accion: "Respuesta  para soporte",
                notificacion: "Tienes respuesta del usuario respecto al ticket " + ticketEdit.numero,
                fecha: Moment(new Date()).format("YYYY-MM-DD"),
                hora: Moment(new Date()).format("HH:mm"),
                leido: false,
                usuarioDe: userName,
                usuarioPara: usuarioSoporte[0].usuario,
                paraSoporte: false,
                activo: true,
                Reg_Ins_Usuario: userName
              };
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones" + JSON.stringify(notificaciones));
              let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
              //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
              notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
              //Se establece para qué usuario es la notificación
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones nuevas" + JSON.stringify(notificaciones));
              await API.graphql({ query: createNotificacionesNuevas, variables: { input: notificaciones } });
            }


          }
          //Si hubo cambios en RespuestaSoporte 
          if (formData.RespuestaSoporte) {//!== ticketM.RespuestaSoporte
            cambios.campoModificado = "Respuesta para el usuario";
            //cambios.valorAnterior = ticketM.RespuestaSoporte;
            delete cambios.valorAnterior;
            cambios.valorActual = formData.RespuestaSoporte;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });

            //Notificaciones para el usuario
            if (usuarioSoporte[0].usuario != ticketEdit.Reg_Ins_Usuario) {
              const notificaciones = {
                modulo: "Atención a usuarios",
                Accion: "Respuesta a usuario",
                notificacion: "Tienes una respuesta en tu ticket número " + ticketEdit.numero,
                fecha: Moment(new Date()).format("YYYY-MM-DD"),
                hora: Moment(new Date()).format("HH:mm"),
                leido: false,
                usuarioDe: userName,
                usuarioPara: ticketEdit.Reg_Ins_Usuario,
                paraSoporte: false,
                activo: true,
                Reg_Ins_Usuario: userName
              };
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones" + JSON.stringify(notificaciones));
              let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
              //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
              notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
              //Se establece para qué usuario es la notificación
              setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones nuevas" + JSON.stringify(notificaciones));
              await API.graphql({ query: createNotificacionesNuevas, variables: { input: notificaciones } });
            }
          }
          //Si hubo cambios en comentariosSoporte 
          if (formData.comentariosSoporte) {//ticketM.comentariosSoporte !== 
            cambios.campoModificado = "Comentarios de soporte";
            //cambios.valorAnterior = ticketM.comentariosSoporte;
            delete cambios.valorAnterior;
            cambios.valorActual = formData.comentariosSoporte;
            await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
          }
          if (formType === 'Editar ticket') {
            //Si hubo cambios en archivo
            if (editarArchivo) {
              cambios.campoModificado = "Archivo";
              cambios.valorAnterior = ticketM.archivoname;
              cambios.valorActual = formData.archivo;
              await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
            }
            //Si hubo cambios en image     
            if (editarImagen) {
              cambios.campoModificado = "Imagen";
              cambios.valorAnterior = ticketM.imagename;
              cambios.valorActual = formData.image;
              await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
            }

          }
          if (formType === 'Atender ticket' || formType === 'Detalle de ticket') {
            //Si hubo cambios en archivo
            if (editarArchivo) {
              cambios.campoModificado = "Archivo";
              cambios.valorActual = archivo.name;
              await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
            }
            //Si hubo cambios en image     
            if (editarImagen) {
              cambios.campoModificado = "Imagen";
              cambios.valorActual = imagen.name;
              await API.graphql({ query: createTicketStatus, variables: { input: cambios } });
            }
          }
          //Se guardan las notificaciones si así corresponde.
          if (stickets && formData.estatus === "Asignado" && cambios.campoModificado === "Asignado a" && userNombreCompleto != formData.asignadoA) {
            //Notificaciones para soporte
            const notificaciones = {
              modulo: "Atención a usuarios",
              Accion: "Tickets se te han asignado",
              notificacion: "Se te ha asignado el ticket " + formData.numero,
              fecha: Moment(new Date()).format("YYYY-MM-DD"),
              hora: Moment(new Date()).format("HH:mm"),
              leido: false,
              usuarioDe: userName,
              usuarioPara: usuarioSoporte[0].usuario,
              paraSoporte: false,
              activo: true,
              Reg_Ins_Usuario: userName
            };
            setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones" + JSON.stringify(notificaciones));
            let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
            //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
            notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
            //Se establece para qué usuario es la notificación
            setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones nuevas" + JSON.stringify(notificaciones));
            await API.graphql({ query: createNotificacionesNuevas, variables: { input: notificaciones } });
          }



          setMensajeAlert("Datos guardados");
          setColor("primary");
          setCargando(false);
          setAVisible(true);
          window.scrollTo(0, 0);
          setisDisabled(false);
          fetchHistorialTicket(ticketEdit.id);
          fetchTickets(rfechaini, rfechafin);
          if (mostrandoHistorial) {
            setEditarImagen(false);
            setEditarArchivo(false);
            setImagen({});
            setArchivo({});
            const ticketmod = ticketEdit;
            //const ticketmod = await fetchTicketsID(ticketEdit.id);
            if (ticketmod.id) {
              delete ticketmod.comentariosUsuario;
              delete ticketmod.RespuestaSoporte;
              delete ticketmod.comentariosSoporte;
              setTicketM(ticketmod);
              updateFormData(ticketmod);
            } else {
              pTickets();
            }
          } else {
            pTickets();
          }
        } else { //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
          window.scrollTo(0, 0);
          /*setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " + 
          " volver a intentarlo, revisando fecha: " + ticketsFromAPI[0].updatedAt + ", fecha de registro actual: "+ formData.updatedAt +
          ", id: " + formData.id);*/
          setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
            " volver a intentarlo");
          setEditarImagen(false);
          setEditarArchivo(false);
          setColor("warning");
          setCargando(false);
          setAVisible(true);
          fetchTickets(rfechaini, rfechafin);
        }
      }

    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar");
      setColor("warning");
      setCargando(false);
      setAVisible(true);
      setisDisabled(false);
    }

  }
  function recargar() {
    fetchTickets(rfechaini, rfechafin);
    fetchUsuario();
  }
  async function busquedaTickets(ticketsinf, estadoTickets, searchb, search, currentPage, asignadosAMI) {
    /* setMensajeAlert(search);
     setColor("warning");
     setAVisible(true);*/
    var pag = 1;
    var bandera = 1;
    var paginasp = [];

    //Filtrado de datos por la búsqueda y el estado de ticket
    const ticketsFromAPI = ticketsinf.sort((a, b) =>
      a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(ticketU =>
        asignadosAMI ? ticketU.asignadoA === userNombreCompleto : ticketU.asignadoA === ticketU.asignadoA).filter(tickets =>
          searchb === "número" ? tickets.numero.toString().toLowerCase().includes(search.toLowerCase()) :
            searchb === "módulo" ? tickets.modulo.toLowerCase().includes(search.toLowerCase()) :
              searchb === "título" ? tickets.titulo.toLowerCase().includes(search.toLowerCase()) :
                searchb === "descripción" ? tickets.descripcion.toLowerCase().includes(search.toLowerCase()) :
                  searchb === "estatus" ? search === "No atendido" ? (tickets.estatus === "Abierto" || tickets.estatus === "Asignado"
                    || tickets.estatus === "En proceso" || tickets.estatus === "Pendiente") : tickets.estatus.toLowerCase().includes(search.toLowerCase()) :
                    searchb === "asignado a" ? tickets.asignadoA.toLowerCase().includes(search.toLowerCase()) :
                      tickets.fechaDeTicket == search);


    await Promise.all(ticketsFromAPI.map(async tickets => {
      //producto.indexnum=bandera;
      tickets.indexpag = pag;
      bandera++;
      if (bandera > recordPerPage) {
        bandera = 1;
        paginasp.push({ pagina: pag });
        pag++;
      }

      return tickets;
    }))


    const lengthtickets = ticketsFromAPI.length;
    if (lengthtickets <= 0)
      setCurrentPage(1);

    setTickets(ticketsFromAPI.filter(paginacion => paginacion.indexpag === currentPage).sort((a, b) =>
      a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
    //TicketsFromAPI.filter(paginacion => paginacion.indexpag === pageNumber)
    setTotalRecords(lengthtickets);
    const prepaginas = parseInt(lengthtickets / recordPerPage);
    const paginas = prepaginas * recordPerPage < lengthtickets ? prepaginas + 1 : prepaginas;
    if (paginas > paginasp.length)
      paginasp.push({ pagina: paginas })

    if (currentPage > 1 && lengthtickets > 0) {
      if (currentPage > paginas) {
        setCurrentPage(paginas);
        const ticketsFromAPIp = ticketsFromAPI.sort((a, b) =>
          a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(tickets =>
            tickets.indexpag === paginas);
        setTickets(ticketsFromAPIp.sort((a, b) =>
          a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
      }
    }

    if (lengthtickets > 0) {
      setPaginas(paginasp);
      setultimoNumeroP(paginasp[paginasp.length - 1].pagina)
    } else {
      setPaginas([]);
      setultimoNumeroP(0)
    }
  }
  //Se revisa si el archivo seleccionado ya existe en la base de datos
  async function onChangedocumento(e) {
    setCargando(true);
    setAVisible(false);
    window.scrollTo(0, 0);
    setDocumentoRepetido(true);
    setisDisabled(true);
    if (!e.target.files[0]) {
      setDocumentoRepetido(false);
      if (!imagenRepetida)
        setisDisabled(false);
      setAVisible(false);
      setCargando(false);
      updateFormData(() => ({ ...formData, [e.target.name]: "" }));
      return
    }
    const file = e.target.files[0];
    const documentesxists = await list({ path: "public/" + file.name });
    if (documentesxists.items.length === 0) {
      setDocumentoRepetido(false);
      if (!imagenRepetida)
        setisDisabled(false);
      setAVisible(false);
      setEditarArchivo(true);
      setArchivo(file);
      setCargando(false);
      updateFormData(() => ({ ...formData, [e.target.name]: file.name }));
      setAVisible(false);
      setCargando(false);
      window.scrollTo(0, 0);
    } else {
      setDocumentoRepetido(true);
      setMensajeAlert("Ya existe un archivo con el mismo nombre: favor de seleccionar otro archivo o cambiar el nombre y volver a intentarlo: ");
      setArchivo({});
      setColor("warning");
      setCargando(false);
      setAVisible(true);
      window.scrollTo(0, 0);
    }
  }
  //Se revisa si la imagen seleccionada ya existe en la base de datos
  async function onChangeimage(e) {
    setCargando(true);
    setAVisible(false);
    window.scrollTo(0, 0);
    setImagenRepetida(true);
    setisDisabled(true);
    if (!e.target.files[0]) {
      setImagenRepetida(false);
      if (!DocumentoRepetido)
        setisDisabled(false);
      setAVisible(false);
      setCargando(false);
      return
    }
    const file = e.target.files[0];
    const imageexist = await list({ path: "public/" + file.name });
    if (imageexist.items.length === 0) {
      setImagenRepetida(false);
      if (!DocumentoRepetido)
        setisDisabled(false);
      setAVisible(false);
      setEditarImagen(true);
      setImagen(file);
      setCargando(false);
      updateFormData(() => ({ ...formData, [e.target.name]: file.name }));
    } else {
      setImagenRepetida(true);
      setMensajeAlert("Ya existe una imagen con el mismo nombre: favor de seleccionar otra imagen o cambiar el nombre de la imagen y volver a intentarlo: ");
      setImagen({});
      setColor("warning");
      setCargando(false);
      setAVisible(true);
      window.scrollTo(0, 0);
    }
  }
  //Diseño de la página
  return (
    <>
      <Navbarh />
      {ptickets == true && (
        <>
          <row>
            <div className="headerp">
              <AiIcons.AiOutlineMessage className="iconoc floatleft" />
              <h3 >{formType /*+" "+ userName*/}</h3>

            </div>
          </row>
          <div className="conteiner2">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>
            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                  <img width="150px" src="assets/img/preloader.gif" />
                </div>
              </Row>
            )}
            {
              formType === 'Sistema de tickets' && (
                <Fragment>
                  <Row>
                    {
                      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-left " >
                        <button class="cbutton btn-success margintop20px ml-3 " onClick={agregarTicket}> <span class="fa fa-plus"> Crear ticket</span> </button>
                      </div>
                    }
                    <div class="col-lg-6 col-md-9 col-sm-12 col-xs-12 text-left  margintopmobil20px" >
                      <InputGroup></InputGroup>
                      <Label><h5>Busqueda por: </h5></Label>
                      <select name="searchBy" className="ml-2" onChange={buscarpor}>
                        <option value="número" selected={searchBy === "número" ? true : false}>Número</option>
                        <option value="módulo" selected={searchBy === "módulo" ? true : false}>Módulo</option>
                        <option value="título" selected={searchBy === "título" ? true : false}>Título</option>
                        <option value="descripción" selected={searchBy === "descripción" ? true : false}>Descripción</option>
                        <option value="fecha" selected={searchBy === "fecha" ? true : false}> Fecha</option>
                        <option value="estatus" selected={searchBy === "estatus" ? true : false}>Estatus</option>
                        {(stickets === true || atickets === true) && (
                          <option value="asignado a" selected={searchBy === "asignado a" ? true : false}>Asignado a</option>
                        )}
                      </select>

                      {(searchBy !== "estatus" && searchBy !== "asignado a") && (
                        <Input
                          name="search"
                          className="marginlbusqueda"
                          type={searchBy !== "fecha" ? "text" : "date"}
                          placeholder={"Búsqueda por " + searchBy}
                          onChange={searchBy !== "fecha" ? (e) => setSearch(e.target.value) : onSearchFecha}
                          onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                          value={search}
                        />
                      )}
                      {searchBy === "estatus" && (
                        <select name="search" className=" custom-select" onChange={onSearch}>
                          <option className="" value="" >Elige una opción </option>
                          <option value="Abierto" selected={search === "Abierto" ? true : false} >Abierto</option>
                          <option value="Asignado" selected={search === "Asignado" ? true : false} >Asignado</option>
                          <option value="En proceso" selected={search === "En proceso" ? true : false} >En proceso</option>
                          <option value="Pendiente" selected={search === "Pendiente" ? true : false} >Pendiente</option>
                          <option value="Atendido" selected={search === "Atendido" ? true : false} > Atendido</option>
                          <option value="No atendido" selected={search === "No atendido" ? true : false} > No atendido</option>
                          <option value="Cerrado" selected={search === "Cerrado" ? true : false} >Cerrado</option>
                        </select>
                      )}
                      {searchBy === "asignado a" && (
                        <select name="search" className=" custom-select" onChange={onSearch}>
                          <option className="" value="" >Elige una opción </option>
                          {usuariosSoporte.map(usuario => (
                            <option value={usuario.nombreCompleto} selected={formData.asignadoA === usuario.nombreCompleto ? true : false}>{usuario.nombreCompleto}</option>
                          ))}
                        </select>
                      )}
                    </div>
                    <div className=" form-group row col-lg-3 col-md-12 col-sm-12 col-xs-12">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Del:</InputGroupText>
                        </InputGroupAddon>
                        <Input name="fechaIni" type="date" value={Moment(rfechaini).format("YYYY-MM-DD")} onChange={onChangesRFecha} />
                      </InputGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Al:</InputGroupText>
                        </InputGroupAddon>
                        <Input name="fechaFin" type="date" value={Moment(rfechafin).format("YYYY-MM-DD")} onChange={onChangesRFecha} />
                      </InputGroup>
                    </div>
                  </Row>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left" >
                    {stickets === true && (
                      <Label className="floatleft"><input type="checkbox" name="VUAP" onChange={(e) => onAsignadosAMi(e.target.checked)} className='ml-2' checked={asignadosAMi} />Asignados a mi</Label>
                    )}
                    <button className="cbutton btn-dark floatright " title="Recargar página" onClick={recargar} ><IoIcons.IoMdRefresh /> Recargar </button>
                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                    <Table className="mb-2 ">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th >Número</Th>
                          <Th >Apertura</Th>
                          <Th >Módulo</Th>
                          <Th >Título</Th>
                          <Th >Descripción</Th>
                          {(stickets === true || atickets === true) && (<Th>Asignado a</Th>)}
                          <Th>Estatus</Th>
                          <Th >Acciones</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {tickets.map((ticket, i) => (
                          <Tr className={(i % 2) !== 0 ? "table-active" : ""}>
                            <Td>{ticket.numero}</Td>
                            <Td>{ticket.fechaDeTicket + " " + (ticket.horaApertura ? ticket.horaApertura : "")}</Td>
                            <Td className="margintopmobil20px">{ticket.modulo}</Td>
                            <Td className="margintopmobil20px">{ticket.titulo}</Td>
                            <Td className="margintopmobil20px">{ticket.descripcion.length > 100 ? ticket.descripcion.substring(0, 97) + "..." : ticket.descripcion}</Td>
                            {(stickets === true || atickets === true) && (<Td>{ticket.asignadoA}</Td>)}
                            <Td className="margintopmobil20px">{ticket.estatus}</Td>
                            <Td className="margintopmobil40px">
                              <button class="btn-info cbutton mt-1 ml-1" onClick={() => clicAccion(ticket, "Detalle de ticket")} title="Detalles"> <IoIcons.IoIosListBox />  </button>
                              <button class="btn-primary cbutton mt-1 ml-1" onClick={() => clicEditar(ticket)} title="Editar"> <IoIcons.IoIosCreate />  </button>
                              {stickets === true && (
                                <button class="btn-success cbutton mt-1 ml-1" onClick={() => clicAccion(ticket, "Atender ticket")} title="Atender ticket"> <IoIcons.IoIosConstruct />  </button>
                              )}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </div>
                  <div className="mt-3 mb-3">
                    Página {currentPage}, mostrando del {(recordPerPage * currentPage - recordPerPage) + 1}  al {totalRecords < recordPerPage * currentPage ? totalRecords : recordPerPage * currentPage} de {totalRecords} registros
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12  ">
                    <div class="floatcenter">
                      <ul class="pagination">
                        <li class={currentPage === 1 ? "page-item disabled" : "page-item"}>
                          <a class="page-link" href="#" aria-label="Go to first page" onClick={() => handlePageChangeTickets(TicketsSinFiltro, 1)}>«</a>
                        </li>
                        <li class={currentPage === 1 ? "page-item disabled" : "page-item"}>
                          <a class="page-link" href="#" aria-label="Go to previous page" onClick={() => handlePageChangeTickets(TicketsSinFiltro, currentPage - 1)}>⟨</a>
                        </li>
                        {paginas.map(pagina => (
                          <li class={currentPage === pagina.pagina ? "page-item active" : "page-item "}>
                            <a class="page-link " onClick={() => handlePageChangeTickets(TicketsSinFiltro, pagina.pagina)}>{pagina.pagina}</a>
                          </li>
                        ))}
                        <li class={currentPage === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                          <a class="page-link" href="#" aria-label="Go to next page" onClick={() => handlePageChangeTickets(TicketsSinFiltro, currentPage + 1)}>⟩</a>
                        </li>
                        <li class={currentPage === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                          <a class="page-link" href="#" aria-label="Go to last page" onClick={() => handlePageChangeTickets(TicketsSinFiltro, ultimoNumeroP)}>»</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/*<div style={{ marginTop: 20 }}>{JSON.stringify(usuariosSoporte)}</div>
                  <div style={{ marginTop: 20 }}>{JSON.stringify(tickets)}</div>*/}
                </Fragment>

              )}

            {
              (formType === 'Nuevo ticket' || formType === 'Editar ticket') && (
                <Fragment>

                  <Row className="" >
                    <div className={"col-lg-4 col-md-4 col-sm-12 col-xs-12"}>
                      <FormGroup>
                        <Label className="floatleft ">Módulo*:</Label>
                        <select name="modulo" className=" custom-select" onChange={onChanges}>
                          <option className="" value="" >Elige una opción</option>
                          <option value="Calidad" selected={formData.modulo === "Calidad" ? true : false}>Calidad</option>
                          <option value="Almacén" selected={formData.modulo === "Almacén" ? true : false}>Almacén</option>
                          <option value="Clientes" selected={formData.modulo === "Clientes" ? true : false}>Clientes</option>
                          <option value="Compras" selected={formData.modulo === "Compras" ? true : false}>Compras</option>
                          <option value="Cotizaciones" selected={formData.modulo === "Cotizaciones" ? true : false}>Cotizaciones</option>
                          <option value="Embarques" selected={formData.modulo === "Embarques" ? true : false}>Embarques</option>
                          <option value="Facturación" selected={formData.modulo === "Facturación" ? true : false}>Facturación</option>
                          <option value="Producción" selected={formData.modulo === "Producción" ? true : false}> Producción</option>
                          <option value="Planeación" selected={formData.modulo === "Planeación" ? true : false}>Planeación</option>
                          <option value="Productos" selected={formData.modulo === "Productos" ? true : false}>Productos</option>
                          <option value="Reciba" selected={formData.modulo === "Reciba" ? true : false}>Reciba</option>
                          <option value="Ubicación" selected={formData.modulo === "Ubicación" ? true : false}>Ubicación</option>
                          <option value="Mantenimiento" selected={formData.modulo === "Mantenimiento" ? true : false}>Mantenimiento</option>
                          <option value="Procesos" selected={formData.modulo === "Procesos" ? true : false}>Procesos</option>
                          <option value="Recursos humanos" selected={formData.modulo === "Recursos humanos" ? true : false}>Recursos humanos</option>
                          <option value="Técnico ambiental" selected={formData.modulo === "Técnico ambiental" ? true : false}>Técnico ambiental</option>
                          {(stickets === true || atickets === true) && (
                            <>
                              <option value="Administrar" selected={formData.modulo === "Administrar" ? true : false}>Administrar</option>
                              <option value="Usuarios" selected={formData.modulo === "Usuarios" ? true : false}>Usuarios</option>
                              <option value="Atención a Usuarios" selected={formData.modulo === "Atención a Usuarios" ? true : false}>Atención a Usuarios</option>
                              <option value="BTI CLOUD" selected={formData.modulo === "BTI CLOUD" ? true : false}>BTI CLOUD</option>
                            </>
                          )}
                        </select>
                        {/*
                        1.mantenimiento
                        2.Procesos
                        3.Recursos humanos
                        4.Tecnico ambiental
                         */}
                      </FormGroup>
                    </div>
                    <div className={"col-lg-4 col-md-4 col-sm-12 col-xs-12"}>
                      <FormGroup>
                        <Label className="floatleft ">Prioridad*:</Label>
                        <select name="prioridad" className=" custom-select" onChange={onChanges}>
                          <option className="" value="" >Elige una Prioridad</option>
                          <option value="Baja" selected={formData.prioridad === "Baja" ? true : false}>Baja</option>
                          <option value="Media" selected={formData.prioridad === "Media" ? true : false}>Media</option>
                          <option value="Alta" selected={formData.prioridad === "Alta" ? true : false}>Alta</option>
                        </select>
                      </FormGroup>
                    </div>
                    {stickets === true && (
                      <>
                        <div className={"col-lg-4 col-md-4 col-sm-12 col-xs-12"}>
                          <FormGroup>
                            <Label className="floatleft ">Asignado a:</Label>
                            <select name="asignadoA" className=" custom-select" onChange={onChanges}>
                              <option className="" value="" >Asignar a </option>
                              {usuariosSoporte.map(usuario => (
                                <option value={usuario.nombreCompleto} selected={formData.asignadoA === usuario.nombreCompleto ? true : false}>{usuario.nombreCompleto}</option>
                              ))}
                            </select>
                          </FormGroup>
                        </div>
                        <div className={"col-lg-2 col-md-2 col-sm-6 col-xs-12"}>
                          <FormGroup>
                            <Label className="floatleft ">Fecha de creación*:</Label>
                            <Input
                              name="fechaDeTicket"
                              type={"date"}
                              onChange={onChanges}
                              value={formData.fechaDeTicket}
                            />
                          </FormGroup>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                          <FormGroup>
                            <Label className="floatleft ">Hora de creación*:</Label>
                            <TimeField name="horaApertura" value={formData.horaApertura} className="w-100 custom-time" onChange={onChanges} />
                          </FormGroup>
                        </div>
                      </>
                    )}
                    <div className={stickets === true ? "col-lg-8 col-md-8 col-sm-12 col-xs-12" : "col-lg-4 col-md-4 col-sm-12 col-xs-12"}>
                      <FormGroup>
                        <Label className="floatleft ">Nombre completo del solicitante:</Label>
                        <Input
                          name="nombreSolicitante"
                          type={"text"}
                          onChange={onChanges}
                          value={formData.nombreSolicitante}
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className={"col-lg-12 col-md-12 col-sm-12 col-xs-12"}>
                      <FormGroup>
                        <Label className="floatleft ">Título*:</Label>
                        <Input name="titulo" maxLength="150" type="text" value={formData.titulo} onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <Col>
                      <FormGroup>
                        <Label className="floatleft ">Descripción*:</Label>
                        <Input name="descripcion" maxLength="1200" type="textarea" value={formData.descripcion} rows="6" onChange={onChanges} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    {stickets === true && (
                      <div className={"col-lg-3 col-md-4 col-sm-12 col-xs-12"}>
                        <FormGroup>
                          <Label className="floatleft ">Tipo de ticket:</Label>
                          <select name="tipo" className=" custom-select" onChange={onChanges}>
                            <option className="" value="" >Elige una opción </option>
                            <option value="Error de sistema" selected={formData.tipo === "Error de sistema" ? true : false}>Error de sistema</option>
                            <option value="Error de red" selected={formData.tipo === "Error de red" ? true : false}>Error de red</option>
                            <option value="Capacitación" selected={formData.tipo === "Capacitación" ? true : false}>Capacitación</option>
                            <option value="Soporte a usuarios" selected={formData.tipo === "Soporte a usuarios" ? true : false}>Soporte a usuarios</option>
                            <option value="Observación de mejora" selected={formData.tipo === "Observación de mejora" ? true : false}>Observación de mejora</option>
                            <option value="Modificación al sistema" selected={formData.tipo === "Modificación al sistema" ? true : false}>Modificación al sistema</option>
                            <option value="Tarea" selected={formData.tipo === "Tarea" ? true : false}>Tarea</option>
                            <option value="Desarrollo" selected={formData.tipo === "Desarrollo" ? true : false}>Desarrollo</option>
                            <option value="Mantenimiento" selected={formData.tipo === "Mantenimiento" ? true : false}>Mantenimiento</option>
                            <option value="Pruebas" selected={formData.tipo === "Pruebas" ? true : false}>Pruebas</option>
                            <option value="Acuerdo de reunión" selected={formData.tipo === "Acuerdo de reunión" ? true : false}>Acuerdo de reunión</option>
                            <option value="Nuevo proyecto" selected={formData.tipo === "Nuevo proyecto" ? true : false}>Nuevo proyecto</option>
                          </select>
                        </FormGroup>
                      </div>
                    )}
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Adjuntar imagen</Label>
                        <Input
                          name="image"
                          type="file"
                          onChange={onChangeimage}
                          accept=".gif,.jpg,.jpeg,.png,.jfif"
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Adjuntar documento</Label>
                        <Input
                          name="archivo"
                          type="file"
                          onChange={onChangedocumento}
                        />
                        {/*archivo.name && (<li  className="floatleft"><a href={formData.archivo} >{archivo.name }</a></li>)*/}
                        {(formData.archivoname && !archivo.name) && (<a href={formData.archivo} >{formData.archivoname}</a>)}
                      </FormGroup>
                    </div>
                  </Row>


                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-5">
                    <div className="floatrightleft" >
                      <button class="cbutton btn-primary  " onClick={!formData.id ? guardarTicket : editarTicket}>  Guardar</button>
                      <button class="cbutton btn-danger ml-3 " onClick={pTickets}>  Terminar</button>
                    </div>
                  </div>
                  {imagen.name && (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <img src={URL.createObjectURL(imagen)} width="100px" title={imagen.name} />
                      {/*imagen.name*/}
                    </div>
                  )}

                  {!editarImagen && (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <img src={formData.image} width="100px" title={formData.imagename} />
                      {/*formData.imagename*/}
                      <a href={formData.image} >{formData.imagename}</a>

                    </div>
                  )}
                  {/*<div style={{ marginTop: 20 }}>{JSON.stringify(imagen)}</div>*/}
                </Fragment>
              )
            }
            {
              (formType === 'Atender ticket' || formType === 'Detalle de ticket') && (
                <Fragment>

                  <Row className="" >
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">
                      <h5 className="floatleft ">{formData.titulo}</h5>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                      <Label className="floatleft backcolorlgray">Ticket: {formData.numero}</Label>
                      <Label className="floatleft ml-2 backcolorlgray">Apertura: {formData.fechaDeTicket + " " + (formData.horaApertura ? formData.horaApertura : "")}</Label>
                      <Label className="floatleft ml-2 backcolorlgray">Módulo: {formData.modulo}</Label>
                      <Label className="floatleft ml-2 backcolorlgray">Tipo: {formData.tipo}</Label>
                      <Label className="floatleft ml-2 backcolorlgray">Prioridad: {formData.prioridad}</Label>
                      {formType === 'Atender ticket' && (
                        <>
                          <Label className="floatleft ml-2 backcolorlgray">Asignado a:
                            <select name="asignadoA" className="" onChange={onChanges}>
                              <option className="" value="" >Asignar a </option>
                              {usuariosSoporte.map(usuario => (
                                <option value={usuario.nombreCompleto} selected={formData.asignadoA === usuario.nombreCompleto ? true : false}>{usuario.nombreCompleto}</option>
                              ))}
                            </select>
                          </Label>
                        </>

                      )}
                      {formType === 'Detalle de ticket' && (
                        <Label className="floatleft ml-2 backcolorlgray">Estatus: {formData.estatus}</Label>
                      )}
                      {(ticketM.archivoname) && (<a className="floatleft ml-2 backcolorlgray" href={ticketM.archivo} >{ticketM.archivoname}</a>)}
                      {ticketM.imagename && (
                        <>
                          <a className="floatleft ml-2 backcolorlgray" href={ticketM.image} >{ticketM.imagename}</a>
                          {/*<img className="floatleft ml-2 " src={formData.image} width="100px" title={formData.imagename} />*/}
                        </>
                      )}
                    </div>
                    {(formType === 'Atender ticket' && (formData.estatus === "Atendido" || formData.estatus === "Cerrado")) && (
                      <>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 ">
                          <Label className="floatleft backcolorlgray">Fecha y hora de atendido:</Label>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 ">
                          <Input
                            className="floatleft"
                            name="fechaDeAtendido"
                            type={"date"}
                            onChange={onChanges}
                            value={formData.fechaDeAtendido}
                          />
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 ">
                          <TimeField name="horaAtendido" value={formData.horaAtendido} className="w-100 custom-time floatleft" onChange={onChanges} />
                        </div>
                      </>
                    )}

                  </Row>
                  <Row>
                    <div className={"col-lg-12 col-md-12 col-sm-12 col-xs-12 mr-3"}>
                      <FormGroup>
                        <Label className="floatleft ">Descripción:</Label>
                        <Input className=" " name="descripcion" maxLength="1200" type="textarea" value={formData.descripcion} readonly="true" rows="6" />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    {formType === 'Atender ticket' && (
                      <div className={"col-lg-3 col-md-3 col-sm-12 col-xs-12"}>
                        <FormGroup>
                          <Label className="floatleft ">Estatus:</Label>
                          <select name="estatus" className=" custom-select" onChange={onChanges}>
                            <option value="Abierto" selected={formData.estatus === "Abierto" ? true : false}>Abierto</option>
                            <option value="Asignado" selected={formData.estatus === "Asignado" ? true : false}>Asignado</option>
                            <option value="En proceso" selected={formData.estatus === "En proceso" ? true : false}>En proceso</option>
                            <option value="Pendiente" selected={formData.estatus === "Pendiente" ? true : false}>Pendiente</option>
                            <option value="Rechazado" selected={formData.estatus === "Rechazado" ? true : false}>Rechazado</option>
                            <option value="Atendido" selected={formData.estatus === "Atendido" ? true : false}>Atendido</option>
                            <option value="Cerrado" selected={formData.estatus === "Cerrado" ? true : false}>Cerrado</option>
                          </select>
                        </FormGroup>
                      </div>
                    )}
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Adjuntar imagen</Label>
                        <Input
                          name="image"
                          type="file"
                          onChange={onChangeimage}
                          accept=".gif,.jpg,.jpeg,.png,.jfif"
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Adjuntar documento</Label>
                        <Input
                          name="archivo"
                          type="file"
                          onChange={onChangedocumento}
                        />
                      </FormGroup>
                    </div>
                    <div className={formType === 'Atender ticket' ? "col-lg-1 col-md-1 col-sm-12 col-xs-12" : "col-lg-4 col-md-4 col-sm-12 col-xs-12"}>
                      <button class="btn-info cbutton mt-1 ml-1 floatrightleft" onClick={(e) => setMostrandoHistorial(!mostrandoHistorial)} title="Ver historial"> <IoIcons.IoMdPaper />  </button>
                    </div>
                    {mostrandoHistorial && (
                      <>

                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll  mb-2">
                          <h5 className='floatleft'> Historial de cambios</h5>
                          <Table >
                            <Thead class="thead-secondary">
                              <Tr>
                                <Th >Fecha</Th>
                                <Th >Hora</Th>
                                <Th >Usuario</Th>
                                <Th >Acción</Th>
                                <Th>Dato modificado</Th>
                                <Th>Valor anterior</Th>
                                <Th>Valor actual</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {historialTicket.map(historial => (
                                ((stickets === true || atickets === true) || historial.Reg_Ins_Usuario === userName || (stickets === false && historial.campoModificado === "Respuesta para el usuario")) && (
                                  <Tr>
                                    <Td>{historial.fecha}</Td>
                                    <Td className="margintopmobil20px">{historial.hora}</Td>
                                    <Td className="margintopmobil20px">{historial.usuario}</Td>
                                    <Td className="margintopmobil20px">{(!historial.valorAnterior || historial.valorAnterior == null) ? "Agregado" : "Modificación"}</Td>
                                    <Td className="margintopmobil20px">{historial.campoModificado}</Td>
                                    <Td className="margintopmobil20px">{(!historial.valorAnterior || historial.valorAnterior == null) ? "" :
                                      historial.archivoAnterior ? <a href={historial.archivoAnterior} >{historial.valorAnterior}</a> : historial.valorAnterior}</Td>
                                    <Td className="margintopmobil40px">{historial.urlArchivo ? <a href={historial.urlArchivo} >{historial.valorActual}</a> : historial.valorActual}</Td>
                                  </Tr>
                                )
                              ))}
                            </Tbody>
                          </Table>
                        </div>
                      </>
                    )}
                    <div className={"col-lg-12 col-md-12 col-sm-12 col-xs-12"}>
                      <FormGroup>
                        <Label className="floatleft ">Comentarios: {/*respuestaUsuario ? "Sí" : "No"*/}</Label>
                        {formType === 'Atender ticket' && (
                          <Label className="floatrightleft mr-3"><input type="checkbox" name="VUAP" onChange={(e) => setRespuestaUsuario(e.target.checked)} className='ml-2' />Respuesta a usuario</Label>
                        )}
                        <Input className=" " name="comentarios" maxLength="1200" type="textarea" value={formData.comentarios ? formData.comentarios : ""} rows="6" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>


                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-5">
                    <div className="floatrightleft" >
                      <button class="cbutton btn-primary  " onClick={editarTicket}>  Guardar</button>
                      <button class="cbutton btn-danger ml-3 " onClick={pTickets}>  Terminar</button>
                    </div>
                  </div>
                  {imagen.name && (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <img src={URL.createObjectURL(imagen)} width="100px" title={imagen.name} />
                      {/*imagen.name*/}
                    </div>
                  )}

                  {!editarImagen && (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">


                    </div>
                  )}
                  {/*<div style={{ marginTop: 20 }}>{JSON.stringify(formData)}</div>*/}
                </Fragment>
              )
            }
          </div>
        </>
      )}
    </>
  )
}

export default Tickets